import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import * as firebase from 'firebase/app';
import { FirestoreService } from 'src/app/services/firestore.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Content } from '@angular/compiler/src/render3/r3_ast';

import { AngularFireMessaging } from '@angular/fire/messaging';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AuthenticationService } from 'src/app/services/authentication.service';


@Component({
  selector: 'app-people-login',
  templateUrl: './people-login.component.html',
  styleUrls: ['./people-login.component.sass']
})
export class PeopleLoginComponent implements OnInit {
  coverPhoto: string = "./assets/img/cover-login.png";
  
  phoneNumber;
  verificationCode;
  recaptchaVerifier: firebase.auth.RecaptchaVerifier;
  verificationId: string;
  uid;

  disableButton: boolean = false;
  visible:boolean = true;
  errorMessageId;
  errorMessageCode;

  constructor(
    private afAuth: AngularFireAuth,
    private auth: AuthenticationService,
    private db: FirestoreService,
    public route: Router,
    private modalService: NgbModal,

    private afMessaging: AngularFireMessaging,
    private afFunctions: AngularFireFunctions
    
  ) {}
  
 
  ngOnInit() {

    // this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
    //   'size': 'invisible',
    //   'callback': (response) => {
    //     // reCAPTCHA solved, allow signInWithPhoneNumber.
    //   },
    //   'senderId': 'PNGL Super-App'
    // });
    //this.sendVerificationCodeToMe();
    //this.sendCustomSMS();
  }

  loginWithGoogle(){    
    this.db.addPeopleWithGoogle()    
    .then(res=>{
      this.uid = res.user.uid;
      this.routePeopleProfilePage();
    }
    )
  }

  sendVerificationCodeToMe() {
    firebase.auth().settings.appVerificationDisabledForTesting = true;
  
    var phoneNumber = "+67572934726";
    var testVerificationCode = "623456";
  
    var appVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
    firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(function (confirmationResult) {
        return confirmationResult.confirm(testVerificationCode); // Uncomment this line to confirm the verification code
      })
      .then(function (result) {
        // Verification code confirmed successfully
        //console.log(result);
      })
      .catch(function (error) {
        // Error; SMS not sent or verification code not confirmed
        //console.error(error);
      });
  }

  // Send custom SMS message
  sendCustomSMS() {
    const customTemplateId = 'your_custom_template_id'; // Replace with your custom template ID
    const phoneNumber = '+67572934726'; // Replace with recipient's phone number
    const message = {
      templateId: customTemplateId,
      phoneNumber: phoneNumber
  };

  // Call Firebase Cloud Function to send SMS using custom template
  const sendCustomSMS = this.afFunctions.httpsCallable('sendCustomSMS');
  sendCustomSMS(message).subscribe(() => {
    //console.log('Custom SMS sent successfully!');
  }, error => {
    //console.error('Error sending custom SMS:', error);
  });
  }
  
  

  async sendVerificationCode(content) {    
    this.modalService.open(content);    
    const phoneNumber = "+675" + this.phoneNumber;
        
    await this.afAuth.signInWithPhoneNumber(phoneNumber, this.recaptchaVerifier)
    .then( result =>{
      this.verificationId = result.verificationId;      
      this.errorMessageId = '';
      this.visible = false;
      if(result){
        this.modalService.dismissAll()
      }    
    }).catch((e) => {
      this.visible = true;
      this.errorMessageId = "Wrong Number! Please enter your 8 digit mobile number and Try Again."        
      //console.error(e);
    }).then(()=>{
      this.modalService.dismissAll()
    })    
      
  }
  openSpinnerModal(content){
    this.modalService.open(content)
  }
  closeSpinnerModal(){
    this.modalService.dismissAll()
  }

  async verifyCode(content) {
    this.modalService.open(content);   
    this.verificationCode = this.verificationCode.toString();
    await this.afAuth.signInWithCredential(auth.PhoneAuthProvider
      .credential(this.verificationId, this.verificationCode))
      .then(credential =>{
        //this.userId = credential.user.uid
        if (credential.additionalUserInfo.isNewUser){
          this.addNewPeopleDb();
          this.routePeopleProfilePage();
        }else{
          this.addExistingPeopleDb();
          this.routePeopleProfilePage();
        }
      }).catch((e) => {   
        this.errorMessageCode = "Wrong Code! Please enter 6 digit code send to +(675)"+this.phoneNumber+", and Try Again.";       
        //console.error(e);
      }).then(()=>{
        this.modalService.dismissAll()
      }
    )
  }

  addNewPeopleDb(){
    const phoneNumber = "+675" + this.phoneNumber
    this.db.addPeopleNewDocPhone(phoneNumber, this.uid)
  }
  addExistingPeopleDb(){
    const phoneNumber = "+675" + this.phoneNumber
    this.db.addPeopleExistingDocPhone(phoneNumber, this.uid)
  }


  // Routing
  routePeopleAddPage(){
    this.route.navigate(['people/add']);
  }
  
  routeHomePage(){
    this.route.navigate(['']);
  }

  routePeopleProfilePage(){
    this.modalService.dismissAll()
    //console.log(this.uid);
    
    this.route.navigate(['people/'+this.uid]);
  }


}
